/**
 * HUB-E — Top articles (vendus / activité récente).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import MagasinBadge from '../MagasinBadge';

export default function ActiviteStockTopList({ title, items, valueKey, valueLabel, testIdPrefix = 'activite-stock' }) {
  if (!items?.length) {
    return (
      <div className="rounded-xl border p-4 text-sm text-[var(--rm-gray-500)]" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
        {title} — aucune donnée sur la période
      </div>
    );
  }

  return (
    <div
      className="rounded-xl border p-4 space-y-2"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <h3 className="text-sm font-semibold text-[var(--rm-white)]">{title}</h3>
      <ul className="space-y-2">
        {items.map((item) => (
          <li key={item.reference} className="flex items-center justify-between gap-2 text-sm">
            <div className="min-w-0 flex items-center gap-2">
              <MagasinBadge code={item.magasin_id || 'M1'} size="sm" />
              <Link
                to={item.id ? `/stock/modifier/${item.id}` : '/stock'}
                className="truncate text-[var(--rm-gray-200)] hover:text-[var(--rm-white)]"
              >
                {item.designation || item.reference}
              </Link>
            </div>
            <span className="font-bold text-[var(--rm-success)] shrink-0">
              {item[valueKey]} {valueLabel}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
